import { ProviderType } from '@/types/bff/gql-schema';

const convertProvider = (provider?: ProviderType) => {
  switch (provider) {
    case ProviderType.Kakao:
      return 'kakao';
    case ProviderType.Naver:
      return 'naver';
    case ProviderType.Apple:
      return 'apple';
    default:
      return 'doctornow';
  }
};

export { convertProvider };
